import { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { FaCreditCard, FaMinus, FaMoneyBillWave, FaPlus, FaTrash, FaUtensils } from "react-icons/fa";
import { FiArrowRight, FiX } from "react-icons/fi";

const persianNumber = new Intl.NumberFormat("fa-IR");

const ClassicCartTheme = (props) => {
  const {
    restaurantData,
    cart,
    tableNumber,
    setTableNumber,
    queryTable,
    tableSuppliedByQr,
    submitting,
    error,
    setError,
    summary,
    changeQuantity,
    removeItem,
    validateCheckout,
    submitOrder,
    goToMenu,
    formatPersianPrice,
  } = props;
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);

  const openPayment = () => {
    if (validateCheckout()) setShowPaymentModal(true);
  };

  const handleSubmit = async () => {
    const success = await submitOrder();
    if (!success) setShowReceipt(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-28" dir="rtl">
      <header className="sticky top-0 z-30 border-b border-gray-100 bg-white/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-3xl items-center gap-3 px-4">
          <button type="button" onClick={goToMenu} aria-label="بازگشت به منو" className="flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-gray-100"><FiArrowRight /></button>
          <div><h1 className="font-black text-gray-900">سبد سفارش</h1><p className="text-xs text-gray-500">{restaurantData?.name}</p></div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl space-y-5 p-4">
        {error && <div role="alert" className="rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}
        {!cart.length ? (
          <div className="rounded-2xl border border-dashed border-gray-200 bg-white px-4 py-16 text-center"><FaUtensils className="mx-auto text-4xl text-gray-300" /><p className="mt-4 font-bold text-gray-800">سبد سفارش خالی است</p><button type="button" onClick={goToMenu} className="mt-4 min-h-11 rounded-xl bg-primary px-5 text-sm font-bold text-white">بازگشت به منو</button></div>
        ) : (
          <>
            <section className="space-y-3" aria-label="آیتم‌های سبد">
              {cart.map((item) => (
                <article key={item._id} className="flex gap-3 rounded-2xl border border-gray-100 bg-white p-3 shadow-sm">
                  <div className="h-20 w-20 shrink-0 overflow-hidden rounded-xl bg-orange-50">{item.image ? <img src={item.image} alt={item.name} className="h-full w-full object-cover" /> : <span className="flex h-full items-center justify-center text-primary/30"><FaUtensils /></span>}</div>
                  <div className="min-w-0 flex-1"><h2 className="truncate font-bold text-gray-900">{item.name}</h2><p className="mt-1 text-xs text-gray-500">هر عدد {formatPersianPrice(item.price)}</p><p className="mt-2 text-sm font-black text-gray-800">{formatPersianPrice(item.price * item.quantity)}</p></div>
                  <div className="flex flex-col items-center justify-between">
                    <button type="button" onClick={() => removeItem(item)} aria-label={`حذف ${item.name}`} className="rounded-lg p-2 text-red-500 hover:bg-red-50"><FaTrash size={13} /></button>
                    <div className="flex items-center rounded-full border border-gray-200 bg-gray-50"><button type="button" onClick={() => changeQuantity(item, -1)} aria-label={`کم کردن ${item.name}`} className="flex h-9 w-9 items-center justify-center"><FaMinus size={10} /></button><span className="w-6 text-center text-sm font-bold">{persianNumber.format(item.quantity)}</span><button type="button" onClick={() => changeQuantity(item, 1)} aria-label={`اضافه کردن ${item.name}`} className="flex h-9 w-9 items-center justify-center"><FaPlus size={10} /></button></div>
                  </div>
                </article>
              ))}
            </section>

            {tableSuppliedByQr ? (
              <section className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                <p className="text-sm font-bold text-gray-800">شماره میز</p>
                <p className="mt-2 text-lg font-black text-primary">میز {persianNumber.format(queryTable)}</p>
                <p className="mt-1 text-xs text-gray-500">شماره میز شما از طریق کد QR ثبت شده است.</p>
              </section>
            ) : (
              <section className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                <label className="block text-sm font-bold text-gray-800">شماره میز
                  <input inputMode="numeric" value={tableNumber} onChange={(event) => { setTableNumber(event.target.value); setError(""); }} placeholder="مثلاً ۱۲" aria-describedby="table-help" className="mt-2 min-h-12 w-full rounded-xl border border-gray-200 p-3 outline-none focus:border-primary focus:ring-2 focus:ring-primary/20" />
                </label>
                <p id="table-help" className="mt-2 text-xs text-gray-500">شماره میز برای ارسال صحیح سفارش ضروری است.</p>
              </section>
            )}

            <section className="flex items-center justify-between rounded-2xl border border-gray-100 bg-white p-4"><div><p className="text-sm text-gray-500">{persianNumber.format(summary.itemCount)} آیتم</p><p className="font-bold text-gray-800">مجموع قابل پرداخت</p></div><p className="text-lg font-black text-secondary">{formatPersianPrice(summary.total)}</p></section>
          </>
        )}
      </main>

      {cart.length > 0 && <div className="fixed inset-x-0 bottom-0 z-30 border-t border-gray-100 bg-white/95 p-3 backdrop-blur"><button type="button" onClick={openPayment} className="mx-auto block min-h-12 w-full max-w-md rounded-xl bg-secondary px-5 font-bold text-white">ادامه و انتخاب پرداخت</button></div>}

      <Dialog open={showPaymentModal && !showReceipt} onClose={() => setShowPaymentModal(false)} fullWidth maxWidth="xs" dir="rtl" PaperProps={{ className: "rounded-2xl" }}>
        <DialogContent className="relative !p-6">
          <IconButton onClick={() => setShowPaymentModal(false)} aria-label="بستن روش‌های پرداخت" className="!absolute !left-3 !top-3"><FiX /></IconButton>
          <h2 className="text-center text-xl font-black">روش پرداخت</h2>
          <div className="mt-6 space-y-3"><button type="button" onClick={() => setShowReceipt(true)} className="flex min-h-12 w-full items-center justify-center gap-3 rounded-xl border border-gray-200 font-bold"><FaMoneyBillWave className="text-green-600" /> پرداخت نقدی در صندوق</button><button type="button" disabled className="flex min-h-12 w-full cursor-not-allowed items-center justify-center gap-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-gray-400"><FaCreditCard /> پرداخت آنلاین — در دسترس نیست</button></div>
        </DialogContent>
      </Dialog>

      <Dialog open={showReceipt} onClose={() => !submitting && setShowReceipt(false)} fullWidth maxWidth="xs" dir="rtl" PaperProps={{ className: "max-h-[calc(100dvh-2rem)] rounded-2xl" }}>
        <DialogContent className="!p-6"><h2 className="text-center text-xl font-black">تأیید سفارش نقدی</h2><div className="mt-5 max-h-64 space-y-2 overflow-y-auto">{cart.map((item) => <div key={item._id} className="flex justify-between rounded-xl bg-gray-50 p-3 text-sm"><span>{item.name} × {persianNumber.format(item.quantity)}</span><span className="font-bold">{formatPersianPrice(item.price * item.quantity)}</span></div>)}</div><div className="mt-4 flex justify-between border-t border-gray-100 pt-4 font-black"><span>جمع کل</span><span>{formatPersianPrice(summary.total)}</span></div><p className="mt-3 text-center text-sm text-gray-500">پرداخت پس از ثبت سفارش در صندوق انجام می‌شود.</p><div className="mt-5 flex gap-2"><button type="button" onClick={() => setShowReceipt(false)} disabled={submitting} className="min-h-11 flex-1 rounded-xl border border-gray-200 font-bold disabled:opacity-50">بازگشت</button><button type="button" onClick={handleSubmit} disabled={submitting} className="min-h-11 flex-[2] rounded-xl bg-secondary font-bold text-white disabled:opacity-50">{submitting ? "در حال ثبت…" : "ثبت نهایی سفارش"}</button></div></DialogContent>
      </Dialog>
    </div>
  );
};

export default ClassicCartTheme;
